// Money formatting shared by the cashier surfaces.
//
// Lives here rather than in CartPanel.js because SellSurface's F15 phone cart
// bar summarises the same figures the panel displays, and the two must format
// identically. Importing it from CartPanel would also have coupled callers to
// a component that test suites routinely mock out, which silently yields
// `undefined` for named exports.
export const money = (currency, value) => `${currency}${(parseFloat(value) || 0).toFixed(2)}`;

// Items in the basket, counting QUANTITIES rather than lines: two of one
// product is two items, not one. Shared for the same reason as money() —
// SellSurface's phone cart bar and CartPanel's own header badge both show
// this number, and a review caught them disagreeing when the bar counted
// `selectedProducts.length` instead.
export const cartItemCount = (selectedProducts = []) =>
    selectedProducts.reduce((sum, p) => sum + (parseInt(p.quantity, 10) || 1), 0);

export default money;
